<div class="p-4">
    <div class="container">
        <h1>Hi {{user.first_name}}!</h1>
        <p>You're logged in with Angular 10!!</p>
        <p><a routerLink="/users">Manage Users</a></p>
    </div>
</div>